module.exports = __webpack_public_path__ + "static/media/warning-contrast.75d0675e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/warning-contrast.svg
// module id = 685
// module chunks = 0